import React, { useState } from 'react'

import { Link } from 'react-router-dom'
import { useRol } from '../../../../../hooks/useRol'
import { Rol } from '../../../../../types/Rol'
import Table, { ColumnDefinitionType } from '../../../../../components/Table'
import { Loading } from '../../../../../components/Loading'
import Confirm from '../../../../../components/Confirm'
import { rolInitial } from '../../../../../context/Seguridad/RolReducer'


const TableRol = () => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const [data, setData] = useState<Rol>(rolInitial);
    const toggle = () => setShowModal(!showModal);

    const eliminar = () => {
        eliminarRol(data.id as unknown as string);
        toggle();
    }

    const { rolList, loading, eliminarRol } = useRol();
    const columns: ColumnDefinitionType<Rol, keyof Rol>[] = [
        {
            key: 'descripcion',
            header: 'Descripción',
        },

        {
            key: 'estado',
            header: 'Estado',
            cell: (data: Rol) => <>{data.estado ? 'Activo' : 'Inactivo'}</>
        },

        {
            key: 'id',
            header: 'Acciones',
            cell: (data: Rol) =>
                <>
                    <Link to={`/roles/editar/${data.id}`} title="Editar" >
                        <i className="fa fa-pencil text-custom" aria-hidden="true"></i>
                    </Link>
                    <Link to="#" title="eliminar"
                        onClick={(e) => {
                            e.stopPropagation();
                            setData(data);
                            setShowModal(true)

                        }}
                    >
                        <i className="fa fa-trash-o mr-2 text-danger" aria-hidden="true"></i>
                    </Link>
                </>
        },
    ]

    return (
        <>
            <Confirm isOpen={showModal} toggle={toggle} title='Eliminar' yesFn={eliminar}>
                <div className="form-horizontal">
                    <div className="row">
                        {<p>Está seguro que desea eliminar el rol {data.descripcion}?</p>}
                    </div>
                </div>
            </Confirm>
            <div className="card">
                <div className="card-body">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ibox float-e-margins">
                                <div className="ibox-title">
                                    <h4 className="m-t-0 header-title">
                                        <i className="fa fa-list-ul" aria-hidden="true" style={{ marginRight: "5px" }}></i>

                                        Lista

                                        <Link to={`/roles/nuevo`} title="Nuevo" className="btn-custom btn-rounded waves-effect waves-light pull-right btn-sm" style={{ marginTop: '-8px' }}>
                                            <i className="fa fa-plus margin-right-10"></i> Nuevo
                                        </Link>
                                    </h4>

                                </div>

                                <div className="table-responsive">
                                    <br />
                                    {loading ? <Loading /> : <Table data={rolList || []} columns={columns}></Table>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div></>
    )
}

export default TableRol;